// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__Aprgx","header":"PatientBlock_header__2VL3S","label":"PatientBlock_label__1NWg_","option":"PatientBlock_option__3s0id"};